<template>
    <div class="informationContainer" :class="{'informationContainerDark' : isDark}">
        <TitleBar title="情报速递" :txt="txt" :type="type"></TitleBar>
        <div class="informationBox" @click="goModelList">
            <div class="informationCard">
                <h2>{{information.title}}</h2>
                <div class="conten">
                    {{information.content}}
                </div>
                <div class="btm">
                    <span class="league" :style="{color: information.color}">{{information.sclass_name}}</span>
                    <!-- <span class="team"><em class="w">{{information.home_name_j}}</em> <em>VS</em> <em class="w">{{information.away_name_j}}</em></span> -->
                    <span class="team">{{information.home_name_j}} <em>{{matchState === '-1' ? (information.homeWholeGoals + ':' + information.awayWholeGoals) : 'VS'}}</em> {{information.away_name_j}}</span>
                    <span class="time">{{createTime}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleBar from './common/titleBar.vue';
import jsbridg from '../../utils/jsbridg';
export default {
    name: 'informationCorpus',
    props: ['information'],
    components: {
        TitleBar
    },
    watch: {
        data: {
            handler () {
                this.renderInformation();
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    data () {
        return {
            type: "19",
            txt: "",
            total: 0,
            matchState: "",
            createTime: ""
        }
    },
    methods: {
        renderInformation () {
            if (this.information) {
                if (this.information.type_num * 1 > 0) {
                    this.txt = '（' + this.information.type_num + '条）';
                } else {
                    this.txt = "";
                }
                this.matchState = this.information.match_state;
                this.createTime = this.information.create_time.substring(2, 16).replace(/-/g, '.');
            }
        },
        goModelList () {
            // this.$emit('goDetail', this.type);
            jsbridg.goWebview({
                url: process.env.VUE_APP_DOMAIN + '/model/report',
                jumptype: 2
            });
        }
    }
}
</script>

<style lang="less" scoped>
.informationContainer{
    width: 100%;
    .informationBox{
        width: 100%;
        padding: 0 14px;
        .informationCard{
            width: 100%;
            height: auto;
            padding: 8px 10px 0px;
            background: #FFFFFF;
            border-radius: 5px;
            h2{
                font-size: 13px;
                font-weight: bold;
                color: #333333;
                text-align: left;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                -webkit-box-orient: vertical;
            }
            .conten{
                font-size: 12px;
                color: #666666;
                text-align: left;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            .btm{
                width: 100%;
                height: 30px;
                line-height: 30px;
                margin-top: 10px;
                font-size: 10px;
                border-top: 1px solid #EEEEEE;
                text-align: center;
                .league{
                    float: left;
                    height: 30px;
                    width: 65px;
                    max-width: 65px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: left;
                }
                .team{
                    color: #333333;
                    em{
                        display: inline-block;
                        vertical-align: middle;
                        color: #FF5048;
                        &.w{
                            color: #333333;
                            max-width: 60px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                }
                .time{
                    float: right;
                    height: 30px;
                    color: #999999;
                }
            }
        }
    }
}
.informationContainerDark {
    background-color: #191919;
    .informationBox {
        .informationCard {
            background: #232323;
            h2{
                color: #d3d3d3;
            }
            .conten {
                color: #a6a6a6;
            }
            .btm{
                border-color: #2f2f2f;
                .team {
                    color: #d3d3d3;
                    em {
                         &.w {
                            color: #d3d3d3;
                         }
                    }
                }
                .time {
                    color: #a6a6a6;
                }
            }
        }
    }
}
</style>
